import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Unscramble from "../Unscramble/index.js";
const RailsMoney = x => x;
const udecodeRailsMoney = {
  unsafeDecode: f => {
    if (Unscramble.isString(f)) {
      const $0 = Unscramble.decodeString(f);
      const v = Data$dMoney$dRounded.fromString($0);
      if (v.tag === "Just") { return v._1; }
      if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid money value: " + $0); }
      $runtime.fail();
    }
    return Data$dInt.unsafeClamp(Data$dNumber.round(Unscramble.decodeNumber(f) * 100.0));
  }
};
const newtypeRailsMoney = {Coercible0: () => {}};
const decodeRailsMoney = {
  decode: f => Control$dMonad$dExcept$dTrans.altExceptT(Data$dList$dTypes.semigroupNonEmptyList)(Data$dIdentity.monadIdentity).alt(Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String")(f))(str => {
    const v = Data$dMoney$dRounded.fromString(str);
    if (v.tag === "Just") { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(v._1); }
    if (v.tag === "Nothing") {
      return Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
        Foreign.$ForeignError("ForeignError", "Invalid money value: " + str),
        Data$dList$dTypes.Nil
      ));
    }
    $runtime.fail();
  }))((() => {
    const $0 = Data$dMoney$dRounded.decodeMoney.decode(f);
    if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
    if ($0.tag === "Right") { return Data$dEither.$Either("Right", $0._1); }
    $runtime.fail();
  })())
};
export {RailsMoney, decodeRailsMoney, newtypeRailsMoney, udecodeRailsMoney};
